import { Component, computed, inject, signal, viewChild } from '@angular/core'
import { Navbar } from '../../common/navbar/navbar.component'
import { MyDatePipe } from '../../../pipes/date.pipe'
import { NgTemplateOutlet } from '@angular/common'
import { AddLeaveRequest } from './add-leave-request/add-leave-request.component'
import { TranslatePipe } from '@ngx-translate/core'
import { LeaveRequest } from '../../../modal/leave-request.modal'
import { LeaveRequestService } from '../../../services/leave-request.service'
import { Tab } from 'bootstrap'

@Component({
  selector: 'app-leave',
  imports: [
    Navbar,
    MyDatePipe,
    NgTemplateOutlet,
    AddLeaveRequest,
    TranslatePipe
  ],
  templateUrl: './leave-request.component.html',
  styleUrl: './leave-request.component.css'
})
export class LeaveRequestComp {
  private lrService = inject(LeaveRequestService)
  private addLeaveRequestComp = viewChild(AddLeaveRequest)
  leaveRequests = signal<LeaveRequest[]>([])
  pendingRequests = computed<LeaveRequest[]>(() =>
    this.leaveRequests().filter((req) => req.applyStatus === 'Pending')
  )
  approvedRequests = computed<LeaveRequest[]>(() =>
    this.leaveRequests().filter((req) => req.applyStatus === 'Approved')
  )
  isDataLoading = true

  constructor() {
    this.getData()
  }

  getData() {
    this.isDataLoading = true
    this.leaveRequests.set([])
    this.lrService.getLeaveRequests().subscribe({
      next: (reqs) => {
        this.leaveRequests.set(reqs.reverse())
        this.isDataLoading = false
      },
      error: () => (this.isDataLoading = false)
    })
  }

  addRequestCallback(req: LeaveRequest) {
    this.leaveRequests.update((reqs) => [req, ...reqs])
    Tab.getOrCreateInstance('#leave-tab-all')?.show()
  }

  showAddLeaveRequest() {
    this.addLeaveRequestComp()?.show()
  }
}
